import { getKeyPointMap } from '../utils';
import { commonFilter } from './filter';

const pageId = '20115';

const influencerBrandOverview = {
  pageName: 'BrandOverview',
  pageId: pageId,
  pagePath: '/opinion/Influencer/BrandOverview',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    IBT_TAB1: {
      buttonId: '2011501',
    },
    IBT_TAB2: {
      buttonId: '2011502',
    },
    IBT_Download: {
      buttonId: '2011503',
    },
    FollowerRange: {
      buttonId: '2011504',
    },
    ...commonFilter,
  },
};

type ButtonType = keyof typeof influencerBrandOverview.button;

type ButtonKeys = { [key in ButtonType]: string };

export const ButtonIdMap: ButtonKeys = getKeyPointMap(
  influencerBrandOverview.button,
) as ButtonKeys;

export default influencerBrandOverview;
